import { enumGovernmentReportingConfigurationSortOption } from '@rematter/frontend-lib-api-client';

import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type GovReportingConfigRecord = QueryAtomResult<
  typeof queryGovReportingConfigsAtom
>[number];

export const queryGovReportingConfigsAtom = createQueryAtomFactory(
  'settings.govReportingConfigs',
  () => ({
    governmentReportingConfigurations: {
      __args: {
        sorting: [enumGovernmentReportingConfigurationSortOption.NameAsc],
        pagination: {
          offset: 0,
          limit: 100,
        },
      },
      entries: {
        id: true,
        serviceType: true,
        name: true,
        uploadType: true,
        recyclerId: true,
        toEmailAddress: true,
        uploadTimezone: true,
        daysOfWeek: true,
        processBatchesAsUnit: true,
        isActive: true,
        fields: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: (data) =>
      data?.governmentReportingConfigurations.entries.map((config) => ({
        id: config.id,
        serviceType: config.serviceType,
        name: config.name,
        uploadType: config.uploadType,
        recyclerId: config.recyclerId,
        toEmailAddress: config.toEmailAddress,
        uploadTimezone: config.uploadTimezone,
        daysOfWeek: config.daysOfWeek,
        processBatchesAsUnit: config.processBatchesAsUnit,
        isActive: config.isActive,
        fields: config.fields,
        createdAt: config.timestamps.createdAt,
        updatedAt: config.timestamps.updatedAt,
      })) ?? [],
  },
);
